import { Navigate, useSearchParams } from "react-router-dom";
import { ResetPassword } from "./ResetPassword";

export const ResetPasswordOrWelcome = () => {
	const [searchParams] = useSearchParams();
	if (searchParams.get("welcome") === "True") {
		return <Navigate to={`/welcome?${searchParams.toString()}`} replace />;
	}
	return <ResetPassword />;
};
